import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Input, DatePicker, InputNumber, Typography } from 'antd';
import { useAppContext } from '../../libs/contextLib';
import dayjs from '../../dayjs';
import config from '../../config';
import DocumentActionsMenu from '../../components/DocumentActionsMenu';
import DocumentHistory from '../../components/DocumentHistory';
import { DATE_STRING } from '../../model/busRoute';

const { TextArea } = Input;
const { Paragraph } = Typography;

const BookingConfirmation = ({ mode, charter, setBookingWith, onAction, preview, mail }) => {
  const { operator } = useAppContext();
  const [logoUrl, setLogoUrl] = useState(null);
  const confirmationDetails = charter.confirmationDetails || {};

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value || 0);
  };

  useEffect(() => {
    if (operator) {
      setLogoUrl(`https://${config.s3.BUCKET}.s3.ap-southeast-2.amazonaws.com/public/${operator?.operatorId}/logo.png?${Date.now()}`);
    }
  }, [operator]);

  const subtotal = charter.calculateSubTotal();
  const afterDiscount = charter.calculateTotalAfterDiscount();
  const gst = charter.calculateGST();
  const total = charter.calculateTotal();

  return <>
    {/* // <Card
    //   title={<DocumentActionsMenu 
    //     mode={mode}
    //     charter={charter} 
    //     onAction={onAction}
    //     currentView="confirmation"
    //     preview={preview}
    //     mail={mail}
    //     type="quote"
    //   />}
    //   bordered={false}
    //   className="card-main"
    // > */}
      <Row gutter={[30, 30]}>
        <Col xs={4} className="d-flex flex-column">
          <label>Confirmed Date</label>
          {mode.edit ? (
            <DatePicker
              value={confirmationDetails.confirmedDate ? dayjs(confirmationDetails.confirmedDate) : dayjs()}
              format={{
                format: DATE_STRING,
                type: "mask",
              }}
              onChange={(date) => setBookingWith('confirmationDetails', { ...confirmationDetails, confirmedDate: date })}
            />
          ) : (
            <strong>{confirmationDetails.confirmedDate ? dayjs(confirmationDetails.confirmedDate).format('DD/MM/YYYY') : '-'}</strong>
          )}
        </Col>
        <Col xs={4} className="d-flex flex-column">
          <label>Deposit Amount</label>
          {mode.edit ? (
            <InputNumber className="w-100"
              defaultValue={0}
              value={confirmationDetails.depositAmount}
              onChange={(value) => setBookingWith('confirmationDetails', { ...confirmationDetails, depositAmount: value })}
              formatter={(value) => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
            />
          ) : (
            <strong>{formatCurrency(confirmationDetails.depositAmount)}</strong>
          )}
        </Col>
        <Col xs={4} className="d-flex flex-column">
          <label>Deposit Due Date</label>
          {mode.edit ? (
            <DatePicker
              value={confirmationDetails.depositDueDate ? dayjs(confirmationDetails.depositDueDate) : dayjs().add(7, 'd')}
              format={{
                format: DATE_STRING,
                type: "mask",
              }}
              onChange={(date) => setBookingWith('confirmationDetails', { ...confirmationDetails, depositDueDate: date })}
            />
          ) : (
            <strong>{confirmationDetails.depositDueDate ? dayjs(confirmationDetails.depositDueDate).format('DD/MM/YYYY') : '-'}</strong>
          )}
        </Col>
        <Col span={12} className="d-flex flex-column">
          <label>Special Instructions</label>
          {mode.edit ? (
            <TextArea
              value={confirmationDetails.specialInstructions}
              onChange={(e) => setBookingWith('confirmationDetails', { ...confirmationDetails, specialInstructions: e.target.value })}
              rows={4}
            />
          ) : (<small>{(confirmationDetails.specialInstructions || '').split('\n').map(p =>
              <Paragraph>{p}</Paragraph>)}</small>)}
        </Col>
      </Row>

      <div className="invoice-totals" style={{marginTop: 30}}>
        <Row className="card-row-content border-full align-items-center">
          <Col className="label-col">
            <strong>Total Charter Amount</strong>
          </Col>
          <Col className="value-col text-right">
            <strong style={{ fontSize: "16px" }}>
              {formatCurrency(total)}
            </strong>
          </Col>
        </Row>
        <Row className="card-row-content border-full align-items-center no-border">
          <Col className="label-col">
            <strong>Deposit Required</strong>
          </Col>
          <Col className="value-col text-right">
            <strong style={{ fontSize: "16px" }}>
              {formatCurrency(confirmationDetails.depositAmount)}
            </strong>
          </Col>
        </Row>
        <Row className="card-row-content border-full align-items-center">
          <Col className="label-col">
            <strong style={{ fontSize: "18px" }}>Balance Due</strong>
          </Col>
          <Col className="value-col text-right">
            <strong style={{ fontSize: "18px" }}>
              {formatCurrency(total - (confirmationDetails.depositAmount || 0))}
            </strong>
          </Col>
        </Row>
      </div>

      {/* // <DocumentHistory charter={charter} />
    // </Card> */}
    </>;
};

export default BookingConfirmation;